/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import './App.css';
import HeaderComponent from './components/shared/Header';
import LeftDrawer from './components/shared/LeftDrawer';
import useStyles from './components/style';
import { deploymentApiUrl } from './constants/Config';

const App = (props) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [deploymentDetails, setDeploymentDetails] = useState(null);
  const { component } = props;
  const classes = useStyles();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
  const fetchDeploymentDetails = () => {
    try {
      fetch(deploymentApiUrl, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          }
          return null;
        })
        .then((response) => {
          if (response) {
            setDeploymentDetails(response);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // ✅ 1. Call API immediately after login
  fetchDeploymentDetails();

  // ✅ 2. Call API again every 10 minutes
  const intervalId = setInterval(fetchDeploymentDetails, 600000);

  // ✅ 3. Cleanup interval
  return () => clearInterval(intervalId);
}, []);

  // console.log(mobileOpen);
  return (
    <Grid container>
      <Grid item md={2} sm={12} xs={12}>
        <LeftDrawer
          // parsedHash={parsedHash}
          handleDrawerToggle={() => handleDrawerToggle()}
          mobileOpen={mobileOpen}
        />
      </Grid>
      <Grid item md={10} sm={12} xs={12} className={classes.mainContainerColor}>
        <HeaderComponent
          {...component.props}
          deploymentDetails={deploymentDetails}
          // parsedHash={parsedHash}
          handleDrawerToggle={() => handleDrawerToggle()}
        />
        <div className="main-section">
          {component}
        </div>
      </Grid>
    </Grid>
  );
};

App.propTypes = {
  component: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  // parsedHash: PropTypes.object.isRequired,
};

export default App;
